@if (sessionUser$ | async; as sessionUser) {
    <section class="content">
        <ul class="nav nav-tabs" role="tablist">
            <!-- Enterprise Details -->
            <li class="nav-item">
                <a
                    class="nav-link"
                    routerLinkActive="tab-link-active"
                    [routerLink]="[enterpriseProfileLink]">
                    Enterprise Details
                </a>
            </li>

            <!-- Employees -->
            @if (sessionUser.isWholesalerEnterprise() || sessionUser.isAdmin()) {
                <li class="nav-item">
                    <a
                        class="nav-link"
                        routerLinkActive="tab-link-active"
                        [routerLink]="[enterpriseEmployeesLink]">
                        Employees
                    </a>
                </li>
            }

            <!-- Admin-only -->
            @if (sessionUser.isAdmin()) {
                <li class="nav-item">
                    <a
                        class="nav-link"
                        routerLinkActive="tab-link-active"
                        [routerLink]="[enterpriseSettingsLink]">
                        Administrative Settings
                    </a>
                </li>

                <li class="nav-item">
                    <a
                        class="nav-link"
                        routerLinkActive="tab-link-active"
                        [routerLink]="[enterpriseTransactionsLink]">
                        Transactions
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        routerLinkActive="tab-link-active"
                        [routerLink]="[enterpriseWalletBalanceLink]">
                        Wallet Balance
                    </a>
                </li>
            }
        </ul>
    </section>
}
